var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Medium/CaretLeft"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.9422 15.8079C13.0003 15.866 13.0463 15.9349 13.0777 16.0108C13.1092 16.0867 13.1254 16.168 13.1254 16.2501C13.1254 16.3322 13.1092 16.4135 13.0777 16.4894C13.0463 16.5653 13.0003 16.6342 12.9422 16.6923C12.8841 16.7504 12.8152 16.7964 12.7393 16.8278C12.6634 16.8593 12.5821 16.8755 12.5 16.8755C12.4179 16.8755 12.3366 16.8593 12.2607 16.8278C12.1848 16.7964 12.1159 16.7504 12.0578 16.6923L5.80782 10.4423C5.74971 10.3842 5.70361 10.3153 5.67215 10.2394C5.6407 10.1636 5.62451 10.0822 5.62451 10.0001C5.62451 9.91797 5.6407 9.83664 5.67215 9.76077C5.70361 9.68489 5.74971 9.61596 5.80782 9.55792L12.0578 3.30792C12.1751 3.19064 12.3342 3.12476 12.5 3.12476C12.6659 3.12476 12.8249 3.19064 12.9422 3.30792C13.0595 3.42519 13.1254 3.58425 13.1254 3.7501C13.1254 3.91596 13.0595 4.07502 12.9422 4.19229L7.1336 10.0001L12.9422 15.8079Z",
    fill: "#27364B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.73c7ca3f944cd382121cfa8611e3c8eb.svg";
export { ForwardRef as ReactComponent };